import React, { Fragment } from "react";
import styled from "styled-components";
import { themeGet } from "styled-system";

import { SmallContainer, MediumContainer } from "../Grid";
import Box from "../Box";
import TextF4 from "../TextF4";
import TextF8 from "../TextF8";
import checkMarkUrl from "../../images/check-mark.svg";
import { FormattedMessage } from "react-intl";

import { currentLocale } from "../../services/locale";

const StyledF4 = styled(TextF4)`
  text-align: center;
  color: white;
`;

const StyledF8 = styled(TextF8)`
  font-family: ${themeGet("fonts.TTNormsProRegular")};
  margin: 0;
`;
const StyledF8White = styled(TextF8)`
  text-align: center;
  color: white;
`;

const DeadlineBox2 = styled.label`
  text-align: left;
  background: white;
  border: 4px solid ${props => (props.checked ? "#19CA94" : "white")};
  border-radius: 8px;
  padding: 2rem;
  margin: 0.75rem;
  width: 100%;
  opacity: ${props => (props.checked ? "1" : "0.5")};
  display: block;
  transition: all 0.2s ease;
  input[type="radio"] {
    display: none;
  }
  :hover {
    opacity: ${props => (props.checked ? 1 : 0.8)};
    cursor: pointer;
  }
`;

const Error = styled.div`
  color: #ff7351;
`;

const CheckBoxInput = styled.label`
  position: relative;
  font-size: 0.875rem;
  font-family: ${themeGet("fonts.TTNormsProRegular")};
  color: white;
  margin-bottom: 2rem;
  :hover {
    cursor: pointer;
  }
  > span {
    padding-left: 40px;
    display: block;
    line-height: 24px;
  }
  .checkbox {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 24px;
    height: 24px;
    border: 2px solid ${props => (props.checked ? "#32c2a2" : "#7572ba")};
    border-radius: 4px;
    background-image: ${props => (props.checked ? `url(${checkMarkUrl})` : "")};
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 12px 12px;
  }
  input[type="checkbox"] {
    appearance: none;
    display: block;
  }
`;
const truish = v => v === "t" || v === true;

export const DeadlineForm = ({
  values,
  touched,
  errors,
  handleBlur,
  handleSubmit,
  handleChange,
}) => (
  <fieldset>
    <MediumContainer pt={5}>
      <StyledF4 mb={4} mt={0}>
        <FormattedMessage id="signUp.howToStudyTitle" />
      </StyledF4>
      <Box display="flex" flexWrap={["wrap", "nowrap"]}>
        <DeadlineBox2 checked={values.deadline === "six-weeks"}>
          <input
            type="radio"
            name="deadline"
            id="deadline-six-weeks"
            onChange={handleChange}
            onBlur={handleBlur}
            value="six-weeks"
          />
          <TextF4 mt={0} mb={3}>
            <FormattedMessage id="signUp.6weeksTitle" />
          </TextF4>
          <StyledF8 mb={2} color="rgba(41,38,76,0.5)">
            <FormattedMessage id="signUp.6weeksSubTitle" />
          </StyledF8>
          <StyledF8>
            <FormattedMessage id="signUp.6weeksText" />
          </StyledF8>
        </DeadlineBox2>
        <DeadlineBox2 checked={values.deadline === "self-paced"}>
          <input
            type="radio"
            name="deadline"
            id="deadline-self-paced"
            onChange={handleChange}
            onBlur={handleBlur}
            value="self-paced"
          />
          <TextF4 mt={0} mb={3}>
            <FormattedMessage id="signUp.selfPacedTitle" />
          </TextF4>
          <StyledF8>
            <FormattedMessage id="signUp.selfPacedText" />
          </StyledF8>
        </DeadlineBox2>
      </Box>
    </MediumContainer>
  </fieldset>
);

export const ECSTFormSweden = ({ showHeader }) => (
  <div>
    {showHeader && (
      <StyledF4 mb={5} mt={4}>
        <FormattedMessage id="signUp.ectsTitleSwe" />
      </StyledF4>
    )}
    <StyledF8White>
      <FormattedMessage id="signUp.ectsStudentSwe" />
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://liu.se/utbildning/kurs/ete318"
      >
        <FormattedMessage id="signup.ectsStudentSweLink" />
      </a>
    </StyledF8White>
  </div>
);

export const ECTSForm = ({
  values,
  touched,
  errors,
  handleBlur,
  handleSubmit,
  handleChange,
  showHeader
}) => (
  <fieldset>
    {showHeader && (
      <StyledF4 mb={5} mt={4}>
        <FormattedMessage id="signUp.ectsTitle" />
      </StyledF4>
    )}

    <CheckBoxInput checked={truish(values.open_university)}>
      <input
        type="checkbox"
        name="open_university"
        id="open_university"
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.open_university}
      />
      <div className="checkbox" />
      <FormattedMessage id="signUp.ectsOpenUni" />
    </CheckBoxInput>
  </fieldset>
);

export const ECTSFormItaly = ({
  values,
  touched,
  errors,
  handleBlur,
  handleSubmit,
  handleChange,
  showHeader,
  intl
}) => (
  <fieldset>
    {showHeader && (
      <StyledF4 mb={5} mt={4}>
        <FormattedMessage id="signUp.ectsTitle" />
      </StyledF4>
    )}
    <StyledF8>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={intl.formatMessage({ id: "routes.ects.faq" })}
      >
        <FormattedMessage id="ects.link" />
      </a>
    </StyledF8>
    <CheckBoxInput  checked={truish(values.open_university)}>

      <input
        type="checkbox"
        name="open_university"
        id="open_university"
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.open_university}
      />
      <div className="checkbox" />
      <FormattedMessage id="signUp.ectsOpenUni" />

    </CheckBoxInput>

  </fieldset>
);

export const ResearchAndMarketingForm = ({
  values,
  touched,
  errors,
  handleBlur,
  handleSubmit,
  handleChange,
  intl,
  hidePolicy
}) => (
  <fieldset>
    <Box mt={5} mb={5} pt={5} borderTop="1px solid white">
      <CheckBoxInput  checked={truish(values.research)}>
        <input
          type="checkbox"
          name="research"
          id="research"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.research}
        />
        <div className="checkbox" />
        <FormattedMessage id="signUp.privacyOptIn" />
      </CheckBoxInput>
      <CheckBoxInput  checked={truish(values.marketing)}>
        <input
          type="checkbox"
          name="marketing"
          id="marketing"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.marketing}
        />
        <div className="checkbox" />
        <FormattedMessage id="signUp.marketingOptIn" />
      </CheckBoxInput>
      {hidePolicy === true ?
        null
        :
        <CheckBoxInput  checked={truish(values.accept_policy)}>
          <input
            type="checkbox"
            name="accept_policy"
            id="accept_policy"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.accept_policy}
          />
          <div className="checkbox" />
          <div style={{ display: 'flex', paddingLeft: '40px', lineHeight: '24px' }}>
            <FormattedMessage id="signUp.acceptPolicyFirst" />
          </div>
        </CheckBoxInput>
      }

    </Box>
  </fieldset>
);

//Helsinki university credits information is not shown in Sweden
//so render right credit form if user is in sweden
const ExtraInfoForm = props => (
  <Fragment>
    {/* <DeadlineForm {...props} /> */}

    <SmallContainer pt={5}>
      {props.values.country === "Sweden" ? (
        <ECSTFormSweden showHeader={true} />
      ) : (
        ["en", "fi", "se"].includes(currentLocale()) && (
          <ECTSForm {...props} showHeader={true} />
        )
      )} {(currentLocale() === "it") && (
        <ECTSFormItaly {...props} showHeader={true} />
      )}
      <ResearchAndMarketingForm {...props} />
    </SmallContainer>
  </Fragment>
);

export default ExtraInfoForm;
